<script setup lang="ts" generic="T extends BaseProps<any>">
import { VR } from "@/widgets";
import { computed } from "vue";
import type { defineActions, defineState } from "../common";
import { Buttons } from "../icons";
import type { BaseProps } from "../props";
import FormTool from "./FormTool.vue";

const props = defineProps<{
    state: ReturnType<typeof defineState>;
    param: T;
    unit?: string;
    actions: ReturnType<typeof defineActions>;
    externalUrl?: string;
}>();

const showScramble = computed(() => import.meta.env.MODE !== "production" && props.state.randomizable);
</script>

<template>
    <div v-if="props.param.embedMode !== 'inline'" class="flex flex-row items-center px-1 justify-between">
        <label class="text-gray-600 font-semibold inline-flex flex-row items-center gap-1 mr-2" :for="props.state.id">
            <VR.RouterLink v-if="externalUrl !== undefined" class="underline text-indigo-600" :to="externalUrl">
                {{ props.param.label + (props.param.required ? "*" : "") }}
            </VR.RouterLink>
            <template v-else>
                {{ props.param.label + (props.param.required ? "*" : "") }}
            </template>
            <span v-if="props.unit !== undefined" class="text-gray-400 font-medium">({{ props.unit }})</span>
            <Buttons.BtnGenerate v-if="props.state.generatable" @click="props.actions.onGenerate" />
            <Buttons.BtnRandom v-if="showScramble" @click="props.actions.onScramble" />
        </label>
        <FormTool :actions="props.actions" :param="props.param" :state="props.state" />
    </div>
</template>
